<template>
  <div v-cloak class="view-wrap">
    <div class="view-content">
      <section class="bg-regular">
        <div class="section-inner">
          <h1 class="team-name text-center" v-if="teamName">{{teamName}}</h1>
          <div class="container">
            <billing></billing>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import billing from '@/views/billing/billing'

export default {
  name: 'billing-contact-billing',
  components: {
    'billing': billing
  },
  data () {
    return {
      teamName: this.$route.query.teamName
    }
  }
}
</script>

<style scoped lang="stylus" src="./billing-contact-billing.styl" >



// WEBPACK FOOTER //
// src/views/billing-contact-billing/billing-contact-billing.vue